import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface DonationRequest {
  organizationName: string;
  contactName: string;
  contactTitle: string;

  email: string;
  phone: string;

  address: string;
  city: string;
  state: string;
  zipCode: string;

  eventName: string;
  eventDate: string | null;
  donationNeededBy: string | null;

  donationType: string;
  requestedAmountOrItems: string;

  additionalInformation: string;
}

@Injectable({
  providedIn: 'root'
})
export class DonationsService {
  private readonly apiUrl = environment.apiUrl + '/donations';

  constructor(private readonly http: HttpClient) {}

  submitDonationRequest(
    request: DonationRequest
  ): Observable<void> {
    return this.http.post<void>(
      this.apiUrl,
      request
    );
  }
}